import React from 'react'
import {connect} from 'react-redux'
import Headline from '../../../Container/Headlines/PageHeadline'
import Requester from './AdminEventDetails/RequesterDetails'
import EventDetails from './AdminEventDetails/EventDetails'
import * as routes from '../../../constants/routes'
import Grid from '@material-ui/core/Grid'
import { defaultGridSettings } from '../../../js/settings/grid'
import InAppNav from '../../../Components/InAppNav/InAppNav'
import { doDeleteEvent } from '../../../firebase/db'
import { deleteMyEvent } from '../../../firebase/database/handleMyEvents'

import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import Button from '@material-ui/core/Button'
const headline = 'Hilfegesuch ohne Helferangebot'
const subtext = null

const AdminEventDetailsNoCanidate = (props) => {

   const { history } = props
    const deleteEvent = () => {
        const eventId = props.openEvent.event.id
        const userId = props.openEvent.requester.id
        doDeleteEvent(eventId)
        deleteMyEvent(userId, eventId)
        history.push(routes.ADMINEVENTS)
        
    }

    if(typeof(props.openEvent.event)==='undefined') {
        history.push(routes.ADMINEVENTS)
        return null
    }
    return (
        <div>
            <Headline headline={headline} subtext={subtext} />
            <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}, {name:'Hilfegesuch vermitteln', route: routes.ADMINEVENTS}]} />
            <Grid container {...defaultGridSettings.container} >
                <Grid item {...defaultGridSettings.item} >
                    <Requester />
                </Grid>
                <Grid item {...defaultGridSettings.item} >
                    <EventDetails />
                </Grid>
                <Grid item {...defaultGridSettings.item} >
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        onClick={deleteEvent}>
                        Hilfebedarf löschen
                    </Button>
                </Grid>



            </Grid>
            
        </div>
    )
}

const mapStateToProps = (state) =>({
    openEvent: state.adminCanidateState.currentOpenEvent
 
 })
 
export default compose(
    connect(mapStateToProps),
    withRouter,
)(AdminEventDetailsNoCanidate)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminEventDetailsNoCanidate.js